import { createFileRoute } from '@tanstack/react-router'
import { ShipmentEditor } from './-ShipmentEditor'

export const Route = createFileRoute('/logistics/shipments/$id')({
  component: ShipmentDetailPage,
})

function ShipmentDetailPage() {
  const { id } = Route.useParams()
  return <ShipmentEditor id={id} />
}
